import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", function () {
  const sliderSelector = ".product-category__slider";
  const slideItems = document.querySelectorAll(
    ".product-category__slider .swiper-slide"
  );
  let slidesCount = slideItems.length;

  const swiper = new Swiper(sliderSelector, {
    slidesPerView: 1,
    spaceBetween: 30,
    touchStartPreventDefault: false,
    passiveListeners: false,
    navigation: {
      nextEl: ".product-category__slider .swiper-button-next",
      prevEl: ".product-category__slider .swiper-button-prev",
    },
    on: {
      init: function () {
        toggleNavigationButtons(this);
      },
      resize: function () {
        toggleNavigationButtons(this);
      },
      breakpoint: function () {
        toggleNavigationButtons(this);
      },
    },
    breakpoints: {
      0: {
        slidesPerView: slidesCount > 1 ? 1 : slidesCount,
      },
      768: {
        slidesPerView: slidesCount > 1 ? 2 : slidesCount,
      },
      992: {
        slidesPerView: slidesCount > 2 ? 2.5 : slidesCount,
      },
      1440: {
        slidesPerView: slidesCount > 2 ? 2.5 : slidesCount,
      },
    },
  });

  function toggleNavigationButtons(swiperInstance) {
    const prevButton = document.querySelector(
      ".product-category__slider .swiper-button-prev"
    );
    const nextButton = document.querySelector(
      ".product-category__slider .swiper-button-next"
    );

    // Get current slidesPerView (can be a number or 'auto')
    const currentSlidesPerView = swiperInstance.params.slidesPerView;
    
    // Check if navigation is needed
    const needsNavigation = slidesCount > Math.floor(currentSlidesPerView);

    if (needsNavigation) {
      if (prevButton) prevButton.style.display = "";
      if (nextButton) nextButton.style.display = "";
    } else {
    if (prevButton) prevButton.style.setProperty('display', 'none', 'important');
if (nextButton) nextButton.style.setProperty('display', 'none', 'important');

    }
  }
});